export default {
  methods: {
    reloadTooltips(timeout = 0) {
      setTimeout(function () {
        const tooltips = $('[data-toggle="tooltip"]');
        tooltips.each(function () {
          const tooltip = $(this);
          const title = tooltip.attr('title');
          const originalTitle = tooltip.data('original-title');
          if (title && originalTitle !== title) {
            tooltip.attr('data-original-title', title);
          }
        });
        tooltips.tooltip();
      }, timeout);
    },
    closeTooltips() {
      const tooltips = $('[data-toggle="tooltip"]');
      tooltips.each(function () {
        $(this).tooltip('destroy');
      });
    }
  }
};


// WEBPACK FOOTER //
// ./resources/js/components/plan/mixins/TooltipMixin.js